import { lazy } from 'react';
import { RouteConfig } from 'react-router-config';

export const alertRedirect = (): RouteConfig[] => [
  {
    path: '/alertRedirect',
    name: '告警跳转',
    component: lazy(() => import('@/presentation/pages/alert-redirect')),
    hideInMenu: true,
  },
  {
    path: '/silence',
    name: '静默',
    component: lazy(() => import('@/presentation/pages/silence')),
    hideInMenu: true,
  },
];

export default alertRedirect;
